// extracted by mini-css-extract-plugin
module.exports = {"description":"DeleteModal_description__3eWmV","deleteButton":"DeleteModal_deleteButton__1SaO7"};